export default "__VITE_ASSET__DVHQABMZ__"